export const INITIATE_GROUP_FORM_ID = 'initiate-group-form';

export const INITIATE_GROUP_SECTION_MAIN_CONTACT_TEST_ID = 'initiate-group-section-main-contact';
export const INITIATE_GROUP_SECTION_PHYSICAL_ADDRESS_TEST_ID = 'initiate-group-section-physical-address';
export const INITIATE_GROUP_SECTION_NOTES_TEST_ID = 'initiate-group-section-notes';
